export const NEW_INPUT_HEIGHT = '2.875rem';
export const NEW_INPUT_PADDING = '10px 16px';
export const NEW_INPUT_BORDER_RADIUS = '5px';
export const NEW_INPUT_FONT_SIZE = '1rem';
